module.exports = __webpack_public_path__ + "img/SCC_B.de99cede.png";